<template>
  <div class="edit-service-page" v-if="$route.query.serviceToEdit">
    <div class="page-header">
      <h1>Edytuj usługę</h1>
      <button class="btn-outline" @click="$router.push('/firm-profile/services-provided')">Wróć do usług</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Dane usługi</h2>
        <p class="section-subtitle">Zmień dane i zapisz aktualizację.</p>
      </div>

      <form class="service-form" @submit="(e) => editService(e)">
        <div class="form-group">
          <label for="serviceName">Nazwa</label>
          <input type="text" id="serviceName" placeholder="Nazwa" v-model="service.title" required maxlength="50" minlength="3">
        </div>

        <div class="form-group">
          <label for="short_description">Krótki opis</label>
          <textarea id="short_description" placeholder="Krótki opis" v-model="service.short_description" required maxlength="350" minlength="20"></textarea>
        </div>

        <div class="form-group">
          <label for="description">Treść</label>
          <textarea id="description" placeholder="Treść" v-model="service.description" required maxlength="3000" minlength="80"></textarea>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label for="address">Adres</label>
            <input type="text" id="address" placeholder="Adres" v-model="service.address" required maxlength="50" minlength="3">
          </div>

          <div class="form-group">
            <label for="state">Województwo</label>
            <select id="state" v-model="service.state">
              <option :value="state.value" :key="state.value" v-for="state in states">{{ state.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="phone">Numer telefonu</label>
            <input type="tel" id="phone" placeholder="Numer telefonu" v-model="service.phone" required pattern="[0-9]{9}">
          </div>

          <div class="form-group">
            <label for="price">Cena</label>
            <input type="number" id="price" placeholder="Cena" v-model="service.price" required>
          </div>

          <div class="form-group">
            <label for="advanceAmount">Wartość zaliczki (%)</label>
            <input type="number" id="advanceAmount" placeholder="Zaliczka" v-model="service.advanceAmount" max="100" required>
          </div>

          <div class="form-group">
            <label for="employee">Pracownik</label>
            <select id="employee" v-model="service.employee">
              <option :value="employee.id" :key="employee.id" v-for="employee in employees">{{ employee.firstname }} {{ employee.lastname }}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="photo">Nowe zdjęcie (opcjonalnie)</label>
          <input type="file" name="photo" id="photo" @change="(e) => onFileUpload(e)">
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">Zatwierdź</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'FirmProfileEditServiceVue',
  setup() {
    useMeta({ title: 'Edytuj usługę' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      states: [],
      service: {
        id: null,
        title: '',
        short_description: '',
        description: '',
        address: '',
        state: '',
        phone: '',
        price: '',
        photo: null,
        employee: '',
        advanceAmount: 0,
      },
      employees: [],
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
      return;
    } else if (this.currentUser.role_id !== 5) {
      this.$router.push('/login');
      return;
    }

    this.getStates();
    this.getEmployees();
    this.getServiceData();
  },
  methods: {
    getServiceData() {
      if (this.$route.query.serviceToEdit) {
        axios.get(`/Service/${this.$route.query.serviceToEdit}`).then(res => {
          if (res.data) {
            this.service.id = res.data.id;
            this.service.title = res.data.name;
            this.service.short_description = res.data.short_description;
            this.service.description = res.data.description;
            this.service.address = res.data.address;
            this.service.state = res.data.state_id;
            this.service.phone = res.data.phone;
            this.service.price = res.data.price;
            this.service.advanceAmount = res.data.advanceAmount;
            this.service.employee = res.data.employee_id;
          } else {
            this.appStore.setIsAlert('nie ma takiej usługi');
          }
        });
      }
    },
    getStates() {
      axios.get('/State').then(res => {
        this.states = [];
        res.data.forEach((item) => {
          this.states.push({
            name: item.name,
            value: `${item.id}`,
          });
        });
      });
    },
    onFileUpload(event) {
      this.service.photo = event.target.files[0];
    },
    editService(e) {
      e.preventDefault();
      const newServiceData = {
        id: this.service.id,
        name: this.service.title,
        short_description: this.service.short_description,
        description: this.service.description,
        address: this.service.address,
        state_id: this.service.state,
        phone: this.service.phone,
        price: this.service.price,
        advanceAmount: this.service.advanceAmount,
        employee_id: this.service.employee ? this.service.employee : null,
      };
      if (this.service.photo) {
        newServiceData.photo = this.service.photo;
      }
      axios.post('/Service', newServiceData, {
        headers: {
          ['Content-Type']: 'multipart/form-data',
        },
      }).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano usługę');
          this.$router.push('/firm-profile/services-provided');
        }
      });
    },
    getEmployees() {
      axios.post(`/Users`, { main_id: this.currentUser.id, page: 1, limit: 100 }, authHeader())
          .then(res => {
            this.employees = res.data.items;
          }).catch(() => {});
    },
  },
};
</script>

<style scoped lang='scss'>
.edit-service-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,.08);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.section-subtitle {
  margin: 6px 0 0;
  font-size: 1.4rem;
  color: #6b7280;
}

.service-form {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  border-color: #10b981;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .edit-service-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>